// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__aW2iX","colMaxWidth":"Table_colMaxWidth__3ii3N"};